import React, { Component } from 'react';
import Videobox2 from '../vediolightbox.js/videobox2';
import Typed from 'react-typed';

class Herosection5 extends Component {
  render() {
    return (
      <section className="p-0 py-2">
        <div className="container">
          <div className="row justify-content-center mb-8">
            <div className="col-12 col-lg-8 text-center">
              {/* Heading */}
              <h4>Created For <Typed
                className="text-primary blue-primary"
                strings={['Institutional', 'Sass', 'Startup', 'Agency', 'Developer']}
                typeSpeed={40}
                backSpeed={50}
                loop >
              </Typed></h4>
              <h1 className="display-4 mt-3 font-w-5">
                Falendi Platform is a All In One Solution
              </h1>
              {/* Text */}
              <p className="lead text-muted">A Beautiful platform that provides an end to end OCR, documents validation, archiving, recycling as well as data integration tools. </p>
            </div>
          </div>
          {/* / .row */}
          <Videobox2 />
        </div>
        {/* / .container */}
      </section>

    );
  }
}

export default Herosection5;